<template>
  <b-form @submit.prevent="evOnSubmit">
    <success-message :message="timeoutMessage" />
    <warning-message
      v-if="step == 0"
      message="A senha deve conter pelo menos um caractere maísculo, um minúsculo e um especial"
    />
    <errors-messages :errors="errors" />
    <b-row>
      <b-col>
        <v-text-field
          :loading="loading"
          disabled
          dense
          outlined
          label="E-mail"
          hide-details
          :value="email"
        />
      </b-col>
    </b-row>
    <b-row v-if="step == 0">
      <b-col>
        <v-text-field-password
          :loading="loading"
          dense
          outlined
          label="Senha"
          hide-details
          ref="autofocus"
          v-model="password"
        />
      </b-col>
    </b-row>
    <b-row v-if="step == 0">
      <b-col>
        <v-text-field-password
          :loading="loading"
          dense
          outlined
          label="Confirmação de senha"
          hide-details
          v-model="password_confirmation"
        />
      </b-col>
    </b-row>
    <b-row v-if="step == 0" align-h="between">
      <b-col cols="auto">
        <v-btn class="v-danger" :disabled="loading" @click="cancel">
          <i class="fas fa-times mr-1"></i>
          {{ canceling ? "CANCELANDO" : "CANCELAR" }}
        </v-btn>
      </b-col>
      <b-col cols="auto">
        <v-btn type="submit" class="btn-save" :disabled="loading">
          <i class="fas fa-save mr-2 text-twenty" />
          {{ saving ? "SALVANDO" : "SALVAR" }}
        </v-btn>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import toast from "../../lib/ToastNotification";
import api from "../../services/api";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import SuccessMessage from "../Components/SuccessMessage.vue";
import VTextFieldPassword from "../Components/VTextFieldPassword.vue";
import WarningMessage from "../Components/WarningMessage.vue";
export default {
  components: {
    WarningMessage,
    ErrorsMessages,
    SuccessMessage,
    VTextFieldPassword,
  },
  name: "RecoverWithToken",
  props: {
    timeoutMessage: String,
    email: String,
    token: String,
  },
  data() {
    return {
      errors: [],
      loading: false,
      canceling: false,
      saving: false,

      step: 0,

      password: "",
      password_confirmation: "",
    };
  },
  mounted() {
    this.$refs.autofocus.focus();
  },
  methods: {
    async evOnSubmit() {
      try {
        this.loading = true;
        this.saving = true;

        let params = {
          token: this.token,
          password: this.password,
          password_confirmation: this.password_confirmation,
        };
        let response = await api.patch("/rest-home/user/new-password", params);
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.step = 1;
          toast(message, "success");
          this.$emit("recovered");
        }

        this.saving = false;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async cancel() {
      try {
        this.loading = true;
        this.canceling = true;

        let params = { token: this.token };
        let response = await api.delete("/rest-home/user/new-password", {
          params,
        });
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.step = 1;
          toast(message, "success");
          this.$emit("canceled");
        }

        this.canceling = false;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
</style>